export const getNormilizeDate = (date, toType = 'ru', setTime = undefined) => {

  if (date !== null && date !== undefined && typeof date === 'string') {
    const rusTypeDate = /\d\d\.\d\d\.\d\d\d\d/g
    const rusTypeDateAndTime = /\d\d\.\d\d\.\d\d\d\d.\d\d:\d\d:\d\d/g
    const engTypeDate = /\d\d\d\d-\d\d-\d\d/g
    const engTypeDateAndTime = /\d\d\d\d-\d\d-\d\d.\d\d:\d\d:\d\d/g
    let d = null
    let t = null
    if (rusTypeDateAndTime.test(date)) {
      d = {
        day: date.split(/\s/)[0].split('.')[0],
        mounth: date.split(/\s/)[0].split('.')[1],
        year: date.split(/\s/)[0].split('.')[2],
      }
      t = !setTime
        ? {
            hour: date.split(/\s/)[1].split(':')[0],
            minute: date.split(/\s/)[1].split(':')[1],
            second: date.split(/\s/)[1].split(':')[2],
          }
        : {
            hour: setTime.split(':')[0],
            minute: setTime.split(':')[1],
            second: setTime.split(':')[2],
          }
    } else if (engTypeDateAndTime.test(date)) {
      d = {
        day: date.split(/\s/)[0].split('-')[2],
        mounth: date.split(/\s/)[0].split('-')[1],
        year: date.split(/\s/)[0].split('-')[0],
      }
      t = !setTime
        ? {
            hour: date.split(/\s/)[1].split(':')[0],
            minute: date.split(/\s/)[1].split(':')[1],
            second: date.split(/\s/)[1].split(':')[2],
          }
        : {
            hour: setTime.split(':')[0],
            minute: setTime.split(':')[1],
            second: setTime.split(':')[2],
          }
    } else if (rusTypeDate.test(date)) {
      d = {
        day: date.split(/\s/)[0].split('.')[0],
        mounth: date.split(/\s/)[0].split('.')[1],
        year: date.split(/\s/)[0].split('.')[2],
      }
    } else if (engTypeDate.test(date)) {
      d = {
        day: date.split(/\s/)[0].split('-')[2],
        mounth: date.split(/\s/)[0].split('-')[1],
        year: date.split(/\s/)[0].split('-')[0],
      }
    }
    if (toType == 'ru') {
      if (t !== null) {
        return `${d.day}.${d.mounth}.${d.year} ${t.hour}:${t.minute}:${t.second}`
      } else {
        if (setTime) {
          const t = {
            hour: setTime.split(':')[0],
            minute: setTime.split(':')[1],
            second: setTime.split(':')[2],
          }
          return `${d.day}.${d.mounth}.${d.year} ${t.hour}:${t.minute}:${t.second}`
        } else {
          return `${d.day}.${d.mounth}.${d.year}`
        }
      }
    } else if (toType == 'en') {
      if (t !== null) {
        return `${d.year}-${d.mounth}-${d.day} ${t.hour}:${t.minute}:${t.second}`
      } else {
        if (setTime) {
          const t = {
            hour: setTime.split(':')[0],
            minute: setTime.split(':')[1],
            second: setTime.split(':')[2],
          }
          return `${d.year}-${d.mounth}-${d.day} ${t.hour}:${t.minute}:${t.second}`
        } else {
          return `${d.year}-${d.mounth}-${d.day}`
        }
      }
    } else {
      throw new Error('No found a end type')
    }
  } else if (date !== null && date !== undefined && date instanceof Date) {
    return date
  } else {
    return undefined
  }
}
